export default "__VITE_ASSET__BR9Z6cZf__"